var _excluded = ["id", "onClick", "title", "hasPaddingLeftRight", "hideTitle", "centerTab", "isActive", "iconLeft", "customIconLeft", "iconRight", "customIconRight", "iconSize", "tabIndex", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, func, bool, oneOf, number, element } from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
var propTypes = {
  /** The text in the tab */
  title: string.isRequired,

  /** Visually hide the title */
  hideTitle: bool,

  /** The parent component `<Tabs>` will generate ids for each tab */
  id: string,

  /** Callback function for clicks on the tab */
  onClick: func,

  /** Justify text/icon in Tab */
  centerTab: bool,

  /** Set to true if the tab is active. (Controlled by parent component `<Tabs>`) */
  isActive: bool,

  /** Name of the icon placed before text. */
  iconLeft: element,

  /** Name of the icon placed after text. */
  iconRight: element,

  /** Place custom icon before text. */
  customIconLeft: string,

  /** Place custom icon after text. */
  customIconRight: string,

  /** Choose if you want padding left and right. */
  hasPaddingLeftRight: bool,

  /** Choose the size of the icon. */
  iconSize: oneOf(['small', 'medium', 'large']),

  /** Add your own tabindex to the tab */
  tabIndex: number,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  iconSize: 'medium',
  centerTab: false,
  hideTitle: false,
  tabIndex: 0,
  hasPaddingLeftRight: true
};
/** The Tab component is used as child of the Tabs component.*/

var Tab = function Tab(_ref) {
  var id = _ref.id,
      onClick = _ref.onClick,
      title = _ref.title,
      hasPaddingLeftRight = _ref.hasPaddingLeftRight,
      hideTitle = _ref.hideTitle,
      centerTab = _ref.centerTab,
      isActive = _ref.isActive,
      iconLeft = _ref.iconLeft,
      customIconLeft = _ref.customIconLeft,
      iconRight = _ref.iconRight,
      customIconRight = _ref.customIconRight,
      iconSize = _ref.iconSize,
      tabIndex = _ref.tabIndex,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-tab__link', {
    'rds-tab__link--active': isActive,
    'rds-tab__link--has-padding-left-and-right': hasPaddingLeftRight
  }, className);
  var contentClassNames = classNames('rds-tab__link-content', {
    'rds-tab--center-tab': centerTab
  });
  var titleClassNames = classNames('rds-tab__link-title', {
    'rds-is-vishidden': hideTitle
  });
  return /*#__PURE__*/React.createElement("li", {
    className: "rds-tab"
  }, /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: componentClassNames,
    onClick: onClick,
    id: id,
    role: "tab",
    "aria-controls": "rds-tab-panel-".concat(id),
    "aria-selected": isActive,
    tabIndex: tabIndex
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: contentClassNames
  }, iconLeft && !customIconLeft && /*#__PURE__*/React.createElement(Icon, {
    component: iconLeft,
    size: iconSize,
    className: "rds-tab__icon rds-tab__icon--left"
  }), customIconLeft && /*#__PURE__*/React.createElement(Icon, {
    customIconPath: customIconLeft,
    size: iconSize,
    className: "rds-tab__icon rds-tab__icon--left"
  }), /*#__PURE__*/React.createElement("span", {
    className: titleClassNames
  }, title), iconRight && !customIconRight && /*#__PURE__*/React.createElement(Icon, {
    component: iconRight,
    size: iconSize,
    className: "rds-tab__icon rds-tab__icon--right"
  }), customIconRight && /*#__PURE__*/React.createElement(Icon, {
    customIconPath: customIconRight,
    size: iconSize,
    className: "rds-tab__icon rds-tab__icon--right"
  }))));
};

Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;
export default Tab;